/* eslint-disable */
import React from 'react'
import { render } from 'react-dom'

/* import css files */
import './index.scss'

// TODO: Remove these styles after face-lift
// Uncomment these 2 lines to display previous UI
// import './common/css/style.scss'
// import './common/css/responsive.scss'

import App from './App'

import * as serviceWorker from './serviceWorker'
import setupServices from './services';

setupServices();

render(<App />,
    document.getElementById('root'),
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
